import { useField, useFormikContext } from 'formik';
import PropTypes from 'prop-types';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import "dayjs/locale/es";
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { TextFieldProps } from '@mui/material';
import { at } from 'lodash';
import dayjs, { Dayjs } from 'dayjs';

interface DatePickerDefaultFieldProps {
  label: string;
  name: string;
  dateAdapter?: typeof AdapterDayjs;
  views?: ('year' | 'month' | 'day')[];
  defaultValue?: Dayjs;
  fullWidth?: boolean;
  [key: string]: any;
}

function DatePickerDefaultField(props: DatePickerDefaultFieldProps) {
  const [field, meta] = useField(props.name);
  const formikProps = useFormikContext();
  const { label, dateAdapter, ...otherProps } = props;

  function _renderHelperText() {
    const [touched, error] = at(meta, 'touched', 'error');
    if (touched && error) {
      return error;
    }
    return '';
  }

  const handleChange = (value: Dayjs | null) => {
    formikProps.setFieldValue(field.name, value);
  };

  return (
    <LocalizationProvider dateAdapter={dateAdapter || AdapterDayjs} adapterLocale="es">
      <DatePicker
        {...otherProps}
        label={label}
        value={field.value ? dayjs(field.value) : null}
        onChange={handleChange}
        slotProps={{
          textField: {
            fullWidth: props.fullWidth !== false,
            error: meta.touched && Boolean(meta.error),
            helperText: _renderHelperText(),
            ...otherProps.textFieldProps
          } as TextFieldProps,
        }}
      />
    </LocalizationProvider>
  );
}

DatePickerDefaultField.defaultProps = {
  label: '',
  name: '',
  dateAdapter: AdapterDayjs,
  views: ['year', 'month', 'day'],
  fullWidth: true
};

DatePickerDefaultField.propTypes = {
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  dateAdapter: PropTypes.any,
  views: PropTypes.arrayOf(PropTypes.oneOf(['year', 'month', 'day'])),
  fullWidth: PropTypes.bool,
};

export default DatePickerDefaultField;